import { useCallback, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useAppAuth } from '../app-context';

export function useSignOut() {
  const auth = useAppAuth();
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);

  const signOut = useCallback(async () => {
    if (!auth || pending) return;
    setPending(true);
    try {
      const logoutUrl = await auth.logout();
      if (logoutUrl) {
        window.location.assign(logoutUrl);
      } else {
        await navigate({ to: '/login' });
      }
    } finally {
      setPending(false);
    }
  }, [auth, navigate, pending]);

  return { signOut, pending, available: auth !== null };
}
